import { createAction } from '@reduxjs/toolkit';

export const showModal = createAction('showModal');
export const hideModal = createAction('hideModal');
export const startPrinting = createAction('startPrinting');
export const endPrinting = createAction('endPrinting');
